import { IntelligenceSectionTitle } from '../common';
import {
  jurisdictionalIntersectionLayerIds,
  nearbyProjectsLayerIds,
  physicalInfrastructureLayerIds,
  rightOfWayLayerIds,
} from '../common/config';

export const LINE_WIDTH = 2;
export const POINT_RADIUS = 10;

export const isPolygon = (f: GeoJSON.Feature) => {
  return f.geometry.type === 'Polygon' || f.geometry.type === 'MultiPolygon';
};

export const isLine = (f: GeoJSON.Feature) => {
  return f.geometry.type === 'LineString' || f.geometry.type === 'MultiLineString';
};

export const isPoint = (f: GeoJSON.Feature) => {
  return f.geometry.type === 'Point' || f.geometry.type === 'MultiPoint';
};

export const layerIdMap: { [key: string]: string[] } = {
  [IntelligenceSectionTitle.NearbyProjects]: nearbyProjectsLayerIds,
  [IntelligenceSectionTitle.RightOfWay]: rightOfWayLayerIds,
  [IntelligenceSectionTitle.JurisdictionalIntersections]: jurisdictionalIntersectionLayerIds,
  [IntelligenceSectionTitle.PhysicalInfrastructure]: physicalInfrastructureLayerIds,
};

export const getActiveLayerIds = (activeSection: IntelligenceSectionTitle): string[] => {
  return layerIdMap[activeSection];
};
